
export enum IconTypeEnum{
  SVG ='SVG', MATERIAL = 'MATERIAL'
}

export enum FormValueTypeEnum {
  TEXT = 'TEXT',
  AMOUNT = 'AMOUNT',
  NUMBER = 'NUMBER',
  SELECTOR = 'SELECTOR',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  URL = 'URL',
  TEL = 'TEL',
  REGION = 'REGION',
  DISTRICT = 'DISTRICT',
  WARD = 'WARD'
}

export enum OwnerTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
  INSTITUTION = 'INSTITUTION',
  BASATA = 'BASATA',
  TFB = 'TFB'
}
